import { ActionGeneratorBuilder } from '../../actions';

export const actions = new ActionGeneratorBuilder('latestEvents')
	.subtype('find', find => find.request('filter').success('maps').fail().cancel())
	.subtype('findForUri', findForUri => findForUri.request({ uri: true, size: true }).success('maps').fail().cancel())
	.build()
;
